/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { StyledTel } from './InputTel.styled';

export type InputTelProps = {
  id: string;
  value?: string;
  placeholder?: string;
  defaultCountry?: any;
  onChange?: (val?: string) => void;
  onFocus?: () => void;
};

const InputTel = forwardRef<HTMLInputElement, InputTelProps>(
  (
    { id, placeholder, defaultCountry, onChange, value, onFocus, ...other },
    ref
  ) => {
    return (
      <StyledTel>
        <PhoneInput
          international={false}
          countryCallingCodeEditable={false}
          defaultCountry={defaultCountry}
          id={id}
          placeholder={placeholder}
          value={value}
          autoComplete={'off'}
          onCountryChange={() => {
            onChange?.(value);
          }}
          onChange={(val) => {
            const value = val ? val.toString() : undefined;

            onChange?.(value);
          }}
          onFocus={onFocus}
          {...other}
          inputRef={ref}
        />
      </StyledTel>
    );
  }
);

InputTel.displayName = 'InputTel';

export default InputTel;
